import {
  FsRound,
  FsRoundsSegmentGroupBase,
} from "db/model/tournament/Segment/FsRoundsSegmentGroup";
import {
  Round,
  RoundsSegmentGroupBase,
} from "model/Tournament/Segment/RoundsSegmentGroup";
import { nonUndefined } from "Utility";
import { mapTournamentSegmentGroupBase } from "./FsTournamentSegmentGroup";

export const mapRoundsSegmentGroupBase = (
  fsModel: FsRoundsSegmentGroupBase
): RoundsSegmentGroupBase => {
  return {
    ...mapTournamentSegmentGroupBase(fsModel),
    roundPrefix: fsModel.roundPrefix ?? "Round",
    rounds: nonUndefined(fsModel.rounds?.map(mapRound) ?? []),
  };
};

const mapRound = (fsModel: FsRound): Round | undefined => {
  if (!fsModel.matchIds || !fsModel.roundNum) {
    return undefined;
  }

  return {
    matchIds: fsModel.matchIds,
    nameOverride: fsModel.nameOverride,
    roundNum: fsModel.roundNum,
  };
};
